import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const UniversityDomainPolarCharts = ({ universityId }) => {
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(true);

  const labels = [
    "Knowledge and Understanding",
    "Skills",
    "Values and Social Responsibility",
  ];

  const colors = ["#363062", "#21b830", "#ff7a00"];

  useEffect(() => {
    const fetchDomainData = async () => {
      try {
        const res = await fetch(
          `https://plo.areez.co/api/main_domain/category/comparison/university?university_id=${universityId}&domain=k,s,v`
        );
        const data = await res.json();

        if (data && data.batch_id) {
          setBatch(data);
        } else {
          console.warn("لا توجد بيانات صالحة:", data);
          setBatch(null);
        }
      } catch (error) {
        console.error("خطأ في تحميل البيانات:", error);
        setBatch(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDomainData();
  }, [universityId]);

  if (loading) return <p className="text-center">جارٍ تحميل البيانات...</p>;

  if (!batch) return <p className="text-center">لا توجد بيانات متاحة.</p>;

  const series = ["k", "s", "v"].map((code) => {
    const domain = batch.categories.find((d) => d.domain_code === code);
    return domain ? domain.average_pct : 0;
  });

  const options = {
    chart: { type: "polarArea", sparkline: { enabled: true } },
    labels: labels,
    fill: { opacity: 1, colors: colors },
    stroke: { width: 0 },
    yaxis: { show: false },
    legend: { position: "bottom" },
    plotOptions: {
      polarArea: { rings: { strokeWidth: 0 } },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
  };

  return (
    <div className="col-md-6 offset-md-3">
      <div className="p-3">
        {/* <h6 className="text-center mb-3">{batch.batch_name}</h6> */}
        <h6 className="text-center mb-3">نسب تحقيق مجالات التعلم الرئيسية في الجامعة</h6>
        <ReactApexChart
          options={options}
          series={series}
          type="polarArea"
          height={250}
        />
      </div>
    </div>
  );
};

export default UniversityDomainPolarCharts;
